import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useLayoutEffect, Children } from "react";
import { requireStaticImageAtomComponent } from "@vfit/shared/data-access";
import { useCookie } from "@vfit/shared/hooks";
import { MainContainer, CustomerTypeBox, OtherInfoBox, ListCustomer, ListOtherInfo, IconMarkerWrapper, Box } from "./head.style";
var Head = function(param) {
    var customerType = param.customerType, otherInfo = param.otherInfo, getContainerHeight = param.getContainerHeight;
    var containerRef = useRef();
    var ref = _sliced_to_array(useCookie("session-domain", ""), 2), _ = ref[0], updateCookie = ref[1];
    useLayoutEffect(function() {
        if (containerRef && containerRef.current && getContainerHeight) {
            getContainerHeight(containerRef.current.clientHeight);
        }
    }, [
        getContainerHeight
    ]);
    var isValidWebUrl = function(url) {
        var regEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/gm;
        return regEx.test(url);
    };
    var setCookie = function(url, indexCookie) {
        if (isValidWebUrl(url)) {
            var ref = new URL(url), currentUrl = ref.origin;
            if (indexCookie === 0) {
                // @ts-ignore
                updateCookie("", -1);
            } else {
                // @ts-ignore
                updateCookie(currentUrl, 20);
            }
        }
        window.location.href = url;
    };
    return /*#__PURE__*/ _jsxs(MainContainer, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx(CustomerTypeBox, {
                children: customerType === null || customerType === void 0 ? void 0 : customerType.map(function(param, indexCookie) {
                    var id = param.id, selected = param.selected, url = param.url, category = param.category;
                    return /*#__PURE__*/ _jsx(ListCustomer, {
                        children: /*#__PURE__*/ _jsx("a", {
                            className: selected === "true" ? "selected" : "",
                            href: "#",
                            onClick: function() {
                                return setCookie(url, indexCookie);
                            },
                            children: category
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ _jsx(OtherInfoBox, {
                children: Children.toArray(otherInfo === null || otherInfo === void 0 ? void 0 : otherInfo.map(function(item) {
                    var ref = item || {
                        logo: {
                            image: ""
                        },
                        url: "",
                        id: ""
                    }, logo = ref.logo, url = ref.url, info = ref.info;
                    var ref1 = requireStaticImageAtomComponent((logo === null || logo === void 0 ? void 0 : logo.image) || ""), src = ref1.src, srcSet = ref1.srcSet;
                    return /*#__PURE__*/ _jsx(ListOtherInfo, {
                        children: /*#__PURE__*/ _jsx(Box, {
                            children: /*#__PURE__*/ _jsxs("a", {
                                href: url,
                                target: "_black",
                                children: [
                                    (logo === null || logo === void 0 ? void 0 : logo.image) && /*#__PURE__*/ _jsx(IconMarkerWrapper, {
                                        children: /*#__PURE__*/ _jsx("img", {
                                            srcSet: srcSet,
                                            src: src,
                                            alt: "icon"
                                        })
                                    }),
                                    info
                                ]
                            })
                        })
                    });
                }))
            })
        ]
    });
};
export default Head;
